import { render, staticRenderFns } from "./Antecedente.vue?vue&type=template&id=21868397&scoped=true&"
import script from "./Antecedente.vue?vue&type=script&lang=js&"
export * from "./Antecedente.vue?vue&type=script&lang=js&"
import style0 from "./Antecedente.vue?vue&type=style&index=0&id=21868397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21868397",
  null
  
)

export default component.exports